import { SUBSCRIBE_PLAN, RATE_CARD, USER_CURRENT_PLAN } from "../../common/constants";

export const subscribePlanAction = function (subscribePlanInfo) {
    return { type: "SUBSCRIBE_PLAN", subscribePlanInfo };
};

export const loadRateCards = function () {

    return { type: RATE_CARD };
}
export const getUserCurrentPlan = function (mmCustomerID) {

    return { type: USER_CURRENT_PLAN, mmCustomerID: mmCustomerID };
}


// WEBPACK FOOTER //
// ./src/Containers/Pricing/actions.js